import React, { useState } from 'react';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';
import styles from './Contato.module.css';

function Contato() {
  const [telefone, setTelefone] = useState('');

  const handleTelefoneChange = (e) => {
    const apenasNumeros = e.target.value.replace(/\D/g, '');
    if (apenasNumeros.length <= 11) {
      setTelefone(apenasNumeros);
    }
  };

  return (
    <div className={styles.paginaContato}>
      
      <section className={styles.bannerContato}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Fale Conosco</h1>
            <p>Estamos prontos para entender as suas necessidades e oferecer as melhores soluções contábeis.</p>
          </div>
        </div>
      </section>

      <section className={`${styles.secaoGenerica} ${styles.bgClaro}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.infoContato}>
            <h2 className={styles.tituloSecao}>Vamos conversar?</h2>
            <p className={styles.textoIntro}>Escolha o canal de sua preferência ou preencha o formulário ao lado. Nossa equipe responderá o mais rápido possível.</p>
            
            <div className={styles.listaCanais}>
              
              <div className={styles.canalItem}>
                <div className={styles.iconeCirculo}>
                  <MdPhone className={styles.iconeInfo} />
                </div>
                <div>
                  <h4>Telefone</h4>
                  <p><a href="tel:+551123650500" className={styles.phoneLink}>(11) 2365 - 0500</a></p>
                </div>
              </div>

              <div className={styles.canalItem}>
                <div className={styles.iconeCirculo}>
                  <MdEmail className={styles.iconeInfo} />
                </div>
                <div>
                  <h4>E-mail</h4>
                  <p><a href="mailto:Para faleconosco@cppcontabilidade.com.br" className={styles.emailLink}> faleconosco@cppcontabilidade.com.br</a></p>
                </div>
              </div>

              <div className={styles.canalItem}>
                <div className={styles.iconeCirculo}>
                  <MdLocationOn className={styles.iconeInfo} />
                </div>
                <div>
                  <h4>Nosso Escritório</h4>
                  <p><a href="https://www.google.com/maps?cid=9022579318684121953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAEYASAB&hl=pt-BR&source=embed" target="_blank" rel="noopener noreferrer" className={styles.addresLink}>Rua General Eloy Alfaro 24, Sala 2 <br/> Vila Mariana, São Paulo - SP, 04139 - 060</a></p>
                </div>
              </div>
            </div>
            <a href="https://wa.link/yztfoa" target="_blank" rel="noopener noreferrer" className={`${styles.btnZap} ${styles.btnCyan}`} aria-label="Falar pelo WhatsApp"><FaWhatsapp size={24} className={styles.iconZap} />Chamar no WhatsApp</a>          
          </div>

          <div className={styles.formContainer}>
            <form action="https://formsubmit.co/faleconosco@cppcontabilidade.com.br" method="POST" className={styles.formulario}>
              <h3 className={styles.formTitulo}>Envie uma mensagem</h3>
              
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_subject" value="Novo contato pelo site da contabilidade!" />
              
              <div className={styles.inputGroup}>
                <label htmlFor="nome">Nome Completo</label>
                <input 
                  type="text" 
                  id="nome" 
                  name="nome" 
                  placeholder="Digite seu nome" 
                  maxLength={50}
                  required 
                />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="email">E-mail de contato</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="seuemail@endereco.com.br" 
                  maxLength={50}
                  required 
                />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="telefone">Telefone / WhatsApp (Apenas números)</label>
                <input 
                  type="tel" 
                  id="telefone" 
                  name="telefone" 
                  placeholder="Ex: 11999999999" 
                  value={telefone}
                  onChange={handleTelefoneChange}
                  minLength={11}
                  maxLength={11}
                  pattern="[0-9]{11}"
                  title="Digite exatamente 11 números, incluindo o DDD."
                  required 
                />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="mensagem">Como podemos ajudar?</label>
                <textarea 
                  id="mensagem" 
                  name="mensagem" 
                  rows="5" 
                  placeholder="Descreva brevemente a sua necessidade..." 
                  maxLength={400}
                  required
                ></textarea>
              </div>

              <button type="submit" className={`${styles.btnSubmit} ${styles.btnAzul}`}>
                Enviar Mensagem
              </button>
              <input type="hidden" name="_next" value="https://www.cppcontabilidade.com.br/contato" />
              <input type="hidden" name="_template" value="box" />
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contato;




